
import { Component, OnInit } from '@angular/core';
import { SchoolSubItemControllerService, SchoolSubscriptionLevelCtlService, SchoolSubscriptionTransportCtlService } from '../api/services';
import * as bootstrap from 'bootstrap';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SchoolClass, SchoolLevel, SchoolSubsClassDto, SchoolSubscriptionClass, SchoolSubscTransportDto, SchoolSubsItem, SchoolSubsItemValue } from '../api/models';
import { SessionService } from '../common/session.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-school-subscription',
  imports: [
    ReactiveFormsModule
],
  templateUrl: './school-subscription.component.html',
  styleUrl: './school-subscription.component.css'
})
export class SchoolSubscriptionComponent implements OnInit {

  levelForm: FormGroup;
  transportForm: FormGroup;
  itemForm: FormGroup;



  message = '';
  step: string = '';
  isAddStep = false;

  subscLevel: Array<SchoolSubsClassDto> = Array.of();
  transports: Array<SchoolSubscTransportDto> = Array.of();
  idPartner: number = 0;
  levels: Array<SchoolLevel> = Array.of();
  classes: Array<SchoolClass>=Array.of();
  messageColor = 'text-success';
  stepData: any;
  itemsToAdd:Array<SchoolSubsItemValue> = Array.of();
  detailedSubscription?:SchoolSubscriptionClass;
  otherItems:Array<SchoolSubsItem> =Array.of();

  constructor(private activeRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private session: SessionService,
    private levelService: SchoolSubscriptionLevelCtlService,
    private transportService: SchoolSubscriptionTransportCtlService,
    private itemService:SchoolSubItemControllerService
  ) {
    this.levelForm = this.formBuilder.group({
      idSubscription: [''],
      yearlyFee: ['', [Validators.required, Validators.min(0)]],
      firstMonthAmount: ['', [Validators.required, , Validators.min(0)]],
      apecAmount: ['', [Validators.required, , Validators.min(0)]],
      idLevel: ['', [Validators.required]],
      idClasse: ['', [Validators.required]]

    });
    this.transportForm = this.formBuilder.group({
      id: [''],
      itinerary: ['', Validators.required],
      subscriptionAmount: ['', [Validators.required, Validators.min(0)]],
      monthlyAmount: ['', [Validators.required, Validators.min(0)]]
    });
    this.itemForm = this.formBuilder.group({
      valueItem:['',Validators.required],
      idItem:['',Validators.required],
      mandatory:['',Validators.required]
    
    });

  }


  ngOnInit(): void {
    this.idPartner = this.session.getSessionInfo().partner?.id!!;
    this.activeRoute.params.subscribe(p => {
      this.step = p['step'];
      console.log(this.step);
      if (this.step === 'level') {
        this.loadLevels();
      } else if (this.step == 'transport') {
        this.loadTransportInfo(this.idPartner);
      }
    });

    if (this.step == 'level') {
      this.loadSubscriptionsLevel(this.idPartner);
    } else if (this.step == 'transport') {
      this.displayListTransport();
    }
    
  }
  getItems(){
    this.itemService.getItems().subscribe({

      next:(resp) =>{
        this.otherItems=resp;
      },
    });
  }

  loadLevels() {
    this.levelService.getAllSchoolLevel().subscribe(
      {
        next: (resp) => {
          this.levels = resp;
        }
      }
    );

  }
  loadClassesByLevel() {
    let idLevel =this.levelForm.value.idLevel;
    if(idLevel){
    this.levelService.getClassByLevel(
      idLevel
    ).subscribe(
      {
        next: (resp) => {
          this.classes = resp;
        }
      }
    );
    }else {
      this.classes=[];
    }

  }
  displayAddStep() {
    this.levelForm.reset();
    this.itemsToAdd = Array.of();
    this.isAddStep = true;

  }
  getSchoolSubscriptionLevel() {
    this.isAddStep = false;
    this.loadSubscriptionsLevel(this.idPartner);

  }
  addSubscriptionLevel() {
    let form = this.levelForm.value;
    console.log(form);
    let dto: SchoolSubsClassDto = {
      apecAmount: form.apecAmount,
      firstMonthAmount: form.firstMonthAmount,
      yearlyFee: form.yearlyFee,
      otherItems: this.itemsToAdd,
      school: {
        id: this.idPartner,
        name: '',
        phone: '',
        address: ''
      },
      classe: {
        id: form.idClasse
      }

    };
    console.log(dto);
    if (form.idSubscription) {
      dto.id = form.idSubscription;
      console.log("update dto")
      console.log(dto);
      this.levelService.updateSubscriptionByLevel(
         dto
      ).subscribe({
        next: () => {
          this.message = "Modification frais d'inscription éffectuée avec succés";
          this.displayDialog(false);
          this.levelForm.reset();
          this.isAddStep = false;
          this.loadSubscriptionsLevel(this.idPartner);
        },
        error: (err) => {
          this.handleError(err);
        }
      })

    } else {

      this.levelService.addSubscriptionByLevel(
        dto
      ).subscribe({
        next: () => {
          this.message = "Frais d'inscription enregistré avec succés";
          this.displayDialog(false);
          this.levelForm.reset();
          this.isAddStep = false;
          this.loadSubscriptionsLevel(this.idPartner);
        },
        error: (err) => {
          this.handleError(err);
        }
      })
    }
  }
  handleError(err: HttpErrorResponse) {
    console.log(err);
    console.log(err.error);

    try {
    this.message = err.error?.message || "Une erreur est survenue lors de l'opération";
    console.log(this.message);
    this.displayDialog(true);
    } catch (error) {
      console.log('error parsing error response');
      this.message = "Une erreur est survenue lors de l'opération";
      this.displayDialog(true);
      
    }
    


  }
  loadSubscriptionsLevel(idPartner: number) {
    this.levelService.getSubscriptionLevelByPartner(
       idPartner
  ).subscribe({
      next: (resp) => {
        this.subscLevel = resp;
      },
      error: (err) => {
        this.handleError(err);
      }
    });
  }
  displayDialog(isError: boolean) {
    if (isError) {
      this.messageColor = 'text-danger';
    } else {
      this.messageColor = 'text-success';
    }
    const modAdd = new bootstrap.Modal('#messageDialog', {});
    modAdd.show();
  }

  displayListTransport() {
    this.loadTransportInfo(this.idPartner);
  }
  onAddTransport() {

    let form = this.transportForm.value;

    let dto: SchoolSubscTransportDto = {
      itinerary: form.itinerary,
      subscription: form.subscriptionAmount,
      monthlyAmount: form.monthlyAmount,
      school: {
        id: this.idPartner,
        name: ' ',
        address: ' ',
        phone: ' '
      }
    };
    console.log(dto);
    if (form.id) {
      dto.id = form.id;
      this.transportService.update(
         dto
      ).subscribe({
        next: () => {
          this.transportForm.reset();
          this.message = "Modification informations transport éffectué avec succés";
          this.displayDialog(false);
          this.isAddStep = false;
          this.loadTransportInfo(this.idPartner);
        },
        error:(err)=> {
          this.handleError(err);
          
        },
      });
    } else {

      this.transportService.addSubscriptionTransport(
         dto
      ).subscribe({
        next: () => {
          this.transportForm.reset();
          this.message = "Frais d'inscription transport enregistré avec succés";
          this.displayDialog(false);
          this.isAddStep = false;
          this.loadTransportInfo(this.idPartner);
        }
      });
    }
  }
  loadTransportInfo(idPartner: number) {

    this.transportService.getSubscriptionTransportByPartner(
       idPartner
    ).subscribe({
      next: (resp) => {
        this.transports = resp;
        this.isAddStep = false;
      },
      error: (err) => {
        this.handleError(err);
      }
    });
  }

  toUpdateStep(data: any) {

    console.log("updata step")
    console.log(data);
    if (this.step == 'level') {
      this.levelForm.controls['idSubscription'].setValue(data.id);
      this.levelForm.controls['yearlyFee'].setValue(data.yearlyFee);
      this.levelForm.controls['firstMonthAmount'].setValue(data.firstMonthAmount);
      this.levelForm.controls['apecAmount'].setValue(data.apecAmount);

      this.levelForm.controls['idLevel'].setValue(data.classe.level.id);
      this.loadClassesByLevel();
      this.levelForm.controls['idClasse'].setValue(data.classe.id);
      this.itemsToAdd = data.otherItems;
      this.isAddStep = true;

    } else {
      this.transportForm.controls['id'].setValue(data.id);
      this.transportForm.controls['itinerary'].setValue(data.itinerary);
      this.transportForm.controls['subscriptionAmount'].setValue(data.subscription);
      this.transportForm.controls['monthlyAmount'].setValue(data.monthlyAmount);
      this.isAddStep = true;
    }

  }
  toDeleteStep(data: any) {
    this.stepData = data;
    console.log("delete step");
    console.log(data);
    if (this.step == 'level') {
     this.message = "Etes vous sur de vouloir supprimer les informations d'inscription  pour le cycle " + data.classe.libelle;
      
    }else if(this.step =='transport'){
       this.message = "Etes vous sur de vouloir supprimer les informations de transport du trajet " + data.itinerary;
    }
    const modAdd = new bootstrap.Modal('#deleteDialog', {});
      modAdd.show();
  }
  confirmDeleteData() {
    if (this.step == 'level') {
      this.deleteSubscriptionLevel();

    } else if (this.step == 'transport') {
      this.deleteTransport();

    }
  }
  deleteSubscriptionLevel() {
    this.levelService.deleteSubscriptionByLevel(
       this.stepData.id
    ).subscribe({
      next: () => {
        this.loadSubscriptionsLevel(this.idPartner);
        this.message = "les informations d'inscription du " + this.stepData.classe.libelle + " ont été supprimées";
        this.messageColor = 'text-success';
        this.stepData = '';
        const modAdd = new bootstrap.Modal('#messageDialog', {});
        modAdd.show();
      },
      error:(err)=>{
         this.handleError(err);
      }
    });
  }
 
  deleteTransport() {

    this.transportService.deleteTransport(
     this.stepData.id
    ).subscribe({
      next: () => {
        this.loadTransportInfo(this.idPartner);
        this.message = "les informations de transport " + this.stepData.itinerary + " ont été supprimées";
        this.messageColor = 'text-success';
        this.stepData = '';
        const modAdd = new bootstrap.Modal('#messageDialog', {});
        modAdd.show();
      },
      error:(err)=>{
         this.handleError(err);
      }
    })
  }
  openOtherItem(){
    
    this.getItems();
    const modAdd = new bootstrap.Modal('#itemDialog', {});
        modAdd.show();

  }
  addOtherItem(){
    let form = this.itemForm.value;
    console.log(form);
    this.itemForm.reset();
    console.log('addOther item')
    let item:SchoolSubsItem = this.otherItems.find(it=>it?.id==form.idItem)!!;
    
    console.log(item);
    let itemValue:SchoolSubsItemValue ={
      value:form.valueItem,
      libelle:item?.libelle,
      id:item?.id,
      mandatory:form.mandatory === "true"
    }
    this.itemsToAdd.push(itemValue);
  }
  removeOtherItem(item:SchoolSubsItemValue){

    const items = this.itemsToAdd.filter(it=>it.libelle!==item.libelle);
      this.itemsToAdd=items;
    

  }
  displayDetails(subsClass:SchoolSubsClassDto){

    console.log(subsClass);
    this.detailedSubscription =subsClass;
    const modAdd = new bootstrap.Modal('#detailsSubscription', {});
        modAdd.show();

  }
}
